<template>
  <div class="section__inner section__inner--noRightpad">
    <div class="section__box section__box--nobg">
      <div class="section__head">
        <h2 class="box-title">{{ title }}</h2>
        <div class="item-img">
          <router-link
            :to="{
              name: 'ProductCategory',
              params: { type: currentType, title, id: categoryid }
            }"
            class="btn--outline btn--sm"
            :class="[currentLanguage === 'AR' ? 'rtlText' : '']"
          >
            {{ $t('button.seemore') }}
          </router-link>
        </div>
      </div>

      <Swiper class="swiper carousel-wrapper carousel-wrapper--smpad" v-bind="swiperProps">
        <SwiperSlide
          v-for="item in products"
          :key="item.product_id"
          :class="isBookType ? 'carousel-item card--v3 card--ebook' : 'carousel-item card--v3'"
        >
          <div
            class="item-img"
            @click="onLinkClick($event, {
              name: 'ProductDetails',
              params: { type: helpers.portal_name, productId: item.product_id }
            })"
          >
            <router-link
              :to="{
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              }"
              @click="onLinkClick($event, {
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              })"
            >
              <img :src="item.icon_small" :alt="title" @error="imageLoadError(item)" />
            </router-link>
          </div>

          <div class="item-data">
            <router-link
              :to="{
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              }"
            >
              <div class="item-data-left">
                <h3
                  class="data-title"
                  @click="onLinkClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: item.product_id }
                  })"
                >
                  {{ item.title }}
                </h3>
                <div class="data-category">{{ item.short_description }}</div>
              </div>
            </router-link>

            <router-link
              class="item-btn"
              :to="{
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              }"
              @click="onLinkClick($event, {
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              })"
            >
              <div class="btn--primary btn--sm">
                <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                  {{ $t('button.playGame') }}
                </span>
                <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                  {{ $t('button.playVideo') }}
                </span>
                <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                  {{ $t('button.download') }}
                </span>
              </div>
            </router-link>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Grid } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/grid'

import { helpers } from '../helper/portal_config'
import EventBus from '../helper/event_bus'

export default {
  name: 'CarouselC',
  props: ['products', 'title', 'categoryid'],
  components: { Swiper, SwiperSlide },
  data() {
    return {
      helpers: '',
      currentType: null,
      currentLanguage: '',
      swiperProps: {
        modules: [Grid],
        loop: false,
        slidesPerView: 1.1,
        spaceBetween: 20,
        slidesPerGroup: 1,
        slidesOffsetAfter: 100,
        grid: { rows: 3, fill: 'row' }, // replaces slidesPerColumn
        breakpoints: {
          667: { slidesPerView: 1.8, grid: { rows: 3, fill: 'row' } },
          767: { slidesPerView: 2.2, grid: { rows: 3, fill: 'row' } },
          1200: {
            slidesPerView: 3,
            grid: { rows: 2, fill: 'row' },
            slidesOffsetAfter: 0,
            grabCursor: false,
            touchRatio: 0,
            spaceBetween: 20
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({ isLoggedIn: 'globals/isLoggedIn' }),
    isBookType() {
      return this.helpers.portal_name === 'Carefizz'
    }
  },
  methods: {
    onLinkClick(e, link) {
      if (!this.isLoggedIn) {
        e.preventDefault()
        EventBus.$emit?.('SHOW_SIGNIN_MODAL', link) || EventBus.emit?.('SHOW_SIGNIN_MODAL', link)
      }
    },
    imageLoadError(item) {
      item.icon_small = 'https://via.placeholder.com/150?text=No+Image'
    },
    getProductType() {
      (this.helpers.menu || []).forEach((item) => {
        if (item.isActive === true) this.currentType = item.type
      })
    },
    setCurrentLanguage() {
      const { host } = window.location
      const country = host.split('.')[0].slice(0, 2).toUpperCase()
      const map = helpers.countryDefaultLanguage || {}
      this.currentLanguage = (map.hasOwnProperty(country) ? map[country] : country).toUpperCase()
    }
  },
  created() {
    this.helpers = helpers
    this.getProductType()
    this.setCurrentLanguage()
  }
}
</script>

<style lang="scss" scoped>
.card--v3 {
  margin-top: 20px;
  margin-bottom: 0;
}
.swiper {
  height: 360px;
  margin-left: auto;
  width: 100%;
  margin-right: auto;

  .swiper-slide { height: 90px!important; }

  @media (min-width: 767px) {
    height: 380px;
    .swiper-slide { height: 90px!important; }
  }

  @media (min-width: 1200px) {
    height: 350px;
    .swiper-slide {
      height: 120px!important;
      margin-bottom: 20px;
      margin-right: 20px!important;
    }
  }

  @media (min-width: 1600px) {
    height: 350px;
    .swiper-slide {
      height: 120px!important;
      margin-bottom: 20px;
      margin-right: 20px!important;
    }
  }
}
.card--v3.card--ebook .item-img img { object-fit: contain; }
.card--v3.card--ebook .item-img { width: 50px; height: 70px; min-width: 60px; flex: 1 0 50px; }
@media (min-width: 1200px) { .card--v3.card--ebook .item-img { width: 70px; height: 100px; flex: 1 0 70px; } }
@media (min-width: 1600px) { .card--v3.card--ebook .item-img { width: 80px; height: 100px; flex: 1 0 80px; } }
</style>
